export const environment = {
  production: true,
  // apiUrl: 'https://top-ptl-dev-684027247.us-west-2.elb.amazonaws.com',
  apiUrl: 'https://dsctopna01test.dhl.com',      // TEST
  // apiUrl: 'https://dsctopna01.dhl.com',          // PROD
  // apiUrl: 'https://dsctopna01dev.dhl.com',       // DEV
  // apiUrl: 'https://top-ptl-sit-2043819649.us-west-2.elb.amazonaws.com',
  isSingleSignOn: true,
  showDashboard: false,
  maintenanceStartTime: '',
  maintenanceEndTime: '',
  maintenanceTime: '15:30 GMT',
  globalBannerMessage : false
};

